import React from "react";
import { Group, Text, Paper } from '@mantine/core';

import { getPropInSubLevelRole } from "../../utils/globalFunctions";

import InputWrapperCustom from "../general/InputWrapperCustom";

const RekomendasiPenerimaDibatalkan = ({ stateData }) => {

    return (
        <React.Fragment>
            <InputWrapperCustom
                stateLabel={stateData.data.label}
                stateWithAsterisk={false}
            >
                <Paper
                    sx={(tema) => ({
                        backgroundColor: tema.colorScheme === 'light' ? '#fff' : tema.colors.dark[7],
                        borderWidth: '1px',
                        borderStyle: 'solid',
                        borderColor: tema.colorScheme === 'light' ? tema.colors.gray[4] : tema.colors.dark[4],
                    })}
                >
                    {!stateData.data.value.id &&
                        <Group
                            noWrap
                            p="xs"
                        >
                            <Text size='sm'>Tidak ada teknisi</Text>
                        </Group>
                    }

                    {stateData.data.value.id &&
                        <Group
                            position="apart"
                            noWrap
                            p="xs"
                        >
                            <Group noWrap>
                                <Text size='sm'>
                                    <Text>
                                        {stateData.data.value.name}
                                    </Text>

                                    <Text size='xs'>
                                        {getPropInSubLevelRole(stateData.data.value.subLevel, 'caption', '-')}
                                    </Text>
                                </Text>
                            </Group>
                        </Group>
                    }
                </Paper>
            </InputWrapperCustom>
        </React.Fragment>
    )
}

export default RekomendasiPenerimaDibatalkan;